export const queryKeys = {
  tasks: ["tasks"] as const,
  task: (id: string) => ["tasks", id] as const,
  lists: ["lists"] as const,
  tags: ["tags"] as const,
  filters: ["filters"] as const,
  attachments: (taskId: string) => ["attachments", taskId] as const,
  links: (taskId: string) => ["links", taskId] as const,
  subtasks: (taskId: string) => ["subtasks", taskId] as const,
  subscription: ["subscription"] as const,
  taskCaptures: ["taskCaptures"] as const,
  agentConnections: ["agentConnections"] as const,
  agentInstructions: ["agentInstructions"] as const,
  listMembers: ["listMembers"] as const,
  // The whole family, for a change that could touch any List's panel — a
  // realtime event names no List, so it has to reach every cached one.
  listMemberDirectories: ["listMemberDirectory"] as const,
  listMemberDirectory: (listId: string) => ["listMemberDirectory", listId] as const,
  taskAuthorEmail: (taskId: string) => ["taskAuthorEmail", taskId] as const,
  listOwnerEmail: (listId: string) => ["listOwnerEmail", listId] as const,
};
